export const typography = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
};
